export type Value = Record<string, unknown>;

const getValue = <T>(key: string, defaultValue?: T): T => {
  const value = JSON.parse(localStorage.getItem(key) as any)

  return value || defaultValue
}

const setValue = (key: string, value: any): void => {
  localStorage.setItem(key, JSON.stringify(value))
}

const pushValue = <T extends Value>(key: string, value: T, identify = 'id'): void => {
  let values = getValue<T[]>(key, [])

  const matchValue = values.find((item) => item[identify] === value[identify])

  if (matchValue) {
    values = values.map((item) => {
      if (item[identify] === value[identify]) {
        return { ...item, ...value }
      }

      return item
    })
  } else {
    values.push(value)
  }

  localStorage.setItem(key, JSON.stringify(values))
}

export default {
  getValue,
  setValue,
  pushValue,
}
